<template>
  <div class="page w-full flex flex-col">
    <div class="page-content h-50px flex text-19px items-center mb-15px">
      <el-select v-model="branch" class="w-150px h-43px" @change="branchChange">
        <el-option v-for="item in branchs" :label="item.name" :value="item.id" :key="item.id"></el-option>
      </el-select>

      <span class="flex-1 mx-20px text-19px text-black font-bold">{{
        modelInfo.project_name_zh
      }}</span>

      <el-button class="common-button" @click="addVersion" v-if="modelInfo.is_show_manage===1">添加版本</el-button>
      <el-button class="common-button" @click="addFile" v-if="modelInfo.is_show_manage===1">添加文件</el-button>
      <el-button class="common-button" @click="choseDownloadContent">下载方式</el-button>
      <!-- <div class="flex ml-30px">
        <img
          v-for="(item, index) in contributor"
          :key="index"
          :src="imageServerUrl + item.avatar"
          class="w-23px h-22px"
          style="margin-left: -0.04rem"
        />
      </div>

      <span class="ml-10px">{{ contributor.length }}名贡献者</span> -->

      <img src="@/assets/images/model/clock.png" class="w-28px h-28px ml-20px" />
      <span class="ml-5px">历史：{{ recentTime }}</span>
    </div>
    <!-- 问题 -->
    <div class="page-content flex items-center p-15px" v-if="hasQuestion" style="background: #f6e2ea">
      <img src="@/assets/images/error.png" class="w-19px h-19px" />
      <span class="text-19px text-default flex-1 mx-10px">{{ question }}</span>
      <img src="@/assets/images/model/error.png" class="w-19px h-19px" @click="
        hasQuestion = false
      updateTableHeight()
        " />
    </div>
    <div class="page-content table-header flex items-center text-19px text-black p-15px" >
      <avatar v-if="modelInfo.creator.avatar" :src="modelInfo.creator.avatar" class="user-avatar" />
      <span class="text-default ml-10px">{{ modelInfo.creator.user_name }}</span>
      <span class="flex-1 ml-40px flex">
        <span v-if="activePath.length > 0" class="path mr-5px"
          @click="changePath('')">{{ modelInfo.project_name_zh }}</span>
        <span v-for="(item, index) in activePath" :key="index">
          /<span class="path mx-5px" @click="changePath(item)">{{
            item.name?item.name:item
          }}</span>
        </span>
      </span>
      <span>更新时间：{{ recentTime }} </span>
    </div>
    <!-- <div class="page-content table-header flex items-center text-19px text-black p-15px" v-if="actionType === 'view'">
      <avatar :src="userBaseInfo.avatar" class="user-avatar" />
      <span class="text-default ml-10px">{{ userBaseInfo.login_name }}</span>
      <span class="ml-40px">{{ editRow.name }}</span>
      <span class="flex-1 ml-40px text-default flex">
        <span v-if="activePath.length > 0" class="path" @click="changePath('')">.</span>
        <span v-for="(item, index) in activePath" :key="index">
          /<span class="path mx-5px" @click="changePath(item)">{{
            item
          }}</span></span>
      </span>
      <span>更新时间：{{ recentTime }} </span>
    </div> -->
    <div class="flex-1 flex flex-col" v-loading="loading.table">
      <div class="flex-1 flex flex-col">
        <auto-height-table class="page-content flex-1" v-if="actionType === ''" :data="tableData" hide-header
          @row-click="rowClick" @cell-click="handleCellClick" ref="auto-height-table" :total="ptotal" :page-sizes="[25,50,100]" @pagination="paginationChange" :noPagination="is_show"> 
          <el-table-column v-for="(item, index) in columns" :key="index" :prop="item.prop" :label="item.label"
            :width="item.width || 'auto'" :show-overflow-tooltip="item.showOverflowTooltip">
            <template slot-scope="scope">
              <!-- 文件名 -->
              <div v-if="item.prop == 'name'" class="text-black" :class="{ 'file-is-dir': scope.row.isDir }" style="
                :hover {
                  text-decoration: underline;
                }
              ">
                {{ scope.row[item.prop] || '-' }}
              </div>
              <!-- 文件大小 -->
              <div v-else-if="item.prop == 'size'" class="flex items-center">
                <!-- 文件夹 -->
                <span v-if="scope.row.isDir">-</span>
                <!-- 非文件夹 -->
                <span v-else>
                  <span class="text-grey-300">{{
                    scope.row[item.prop] || '-'
                  }}</span>
                  <span v-if="scope.row.isLFS" class="text-14px font-bold text-black rounded-5px ml-10px px-7px mb-1px"
                    style="border: 1px solid #000">LFS</span>
                </span>
              </div>
              <!-- 文件说明 -->
              <div v-else-if="item.prop == 'subject'">
                <!-- 文件夹 -->
                <span v-if="scope.row.isDir">文件夹</span>
                <!-- 非文件夹 -->
                <span v-else>
                  {{ scope.row[item.prop] || '-' }}
                </span>
              </div>

              <span v-else class="text-grey-300">{{
                scope.row[item.prop] || '-'
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80px" @click.native.stop>
            <template slot-scope="scope">
              <!-- <el-button class="px-10px" type="text" @click="view(scope.row)"
              >查看</el-button
            >
            <el-button class="px-10px" type="text" @click="edit(scope.row)"
              >编辑</el-button
            > -->
              <el-button class="px-10px dwn" v-if="!scope.row.isDir" type="text" :loading="scope.row.downloadLoading"
                @click.stop="download(scope.row)">下载</el-button>
            </template>
          </el-table-column>
        </auto-height-table>
        <!-- 文件预览 -->
        <div class="page-content h-full p-10px bg-white " v-if="actionType!=''">
          <!-- <MarkdownViewer :content="codeedit"></MarkdownViewer> -->
          <!-- <div class="mt-20px markdown-body" v-html="toMarkdown(codeedit)"></div> -->
          <router-view ></router-view>
        </div>
       
      </div>
      <!-- 查看文件 -->
      <!-- <div class="page-content h-full p-10px bg-white" v-if="actionType === 'view'">
        <div v-for="(item, index) in editRow.content" :key="index">
          {{ index + 1 }}.<span class="mx-10px">{{ item }}</span>
        </div>
      </div> -->
      <!-- 编辑文件 -->
      <div class="w-full h-full pt-10px flex flex-col" v-if="actionType === 'edit'">
        <div class="page-content px-15px py-10px flex-1 overflow-hidden flex flex-col" style="background: #eae7ef">
          <div class="flex">
            <span class="mr-15px">文件名称</span>
            <span class="flex-1 text-black">{{ editRow.fileName }}</span>
            <span class="text-black">更新时间：{{ editRow.time }}</span>
          </div>
          <div class="flex-1 overflow-hidden flex mt-5px">
            <span class="mr-15px mt-10px">文件内容</span>
            <div class="flex-1 overflow-hidden bg-white flex flex-col">
              <div class="px-15px py-10px flex" style="border-bottom: 1px solid #e1dce9">
                <span class="text-default cursor-pointer mr-50px">编辑</span>
                <span class="text-default cursor-pointer">预览</span>
                <div class="flex-1 text-right">
                  为了让您的模型更容易被阅读和理解，推荐按照模版内容进行填写
                  <span class="text-pri cursor-pointer">使用模版编辑器</span>
                </div>
              </div>
              <div class="flex-1 overflow-y-auto relative">
                <el-input type="textarea" v-model="editRow.content"> </el-input>
                <!-- 小窗预览 -->
                <div style="border: 1px dashed #666; top: 20px; right: 20px"
                  class="w-142px h-187px p-10px absolute bg-white overflow-y-auto">
                  <embed src="/file-view.html?id=12345" type="text/html" width="100%" height="100%" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bg-white text-right py-10px px-15px">
          <el-button>取消</el-button>
          <el-button type="primary">提交修改</el-button>
        </div>
      </div>
    </div>
    <div class="page-content">
      <Footer />
    </div>
    <!-- 添加版本弹窗 -->
    <el-dialog :visible.sync="visible.addVersion" width="3.9rem" :close-on-press-escape="false">
      <div slot="title">
        <span class="text-black font-bold">添加版本</span>
        <span class="text-default ml-20px">{{ modelInfo.title }}</span>
      </div>
      <add-version ref="add-version"></add-version>
      <div slot="footer">
        <el-button type="primary" @click="finishAddVersion" :loading="loading.addVersion">完成</el-button>
      </div>
    </el-dialog>
    <!-- 添加文件弹窗 -->
    <el-dialog :visible.sync="visible.addFile" :close-on-press-escape="false" @close="close">
      <div slot="title">
        <span class="text-black font-bold">添加文件</span>
        <span class="text-default ml-20px">{{ modelInfo.title }}</span>
      </div>
      <add-file ref="add-file" :dirlist="dirlist" @search="addfileslist"></add-file>
      <div slot="footer">
        <!-- <el-button type="primary" @click="finishAddFile" :loading="loading.addFile">完成</el-button> -->
      </div>
    </el-dialog>
    <!-- 异步提交提醒窗口 -->
    <el-dialog :visible.sync="visible.asyncCommit" width="3.9rem" :close-on-press-escape="false">
      <div slot="title">
        <span class="text-black font-bold">异步提交</span>
        <span class="text-default ml-20px">{{ modelInfo.title }}</span>
      </div>
      <div class="mt-10px text-black">
        网页端大文件上传，超过100M的文件将会在后台完成版本控制处理，可以在个人中心的消息中查看完成情况。
      </div>
      <div slot="footer">
        <el-button type="primary" @click="aknowledgeAsyncCommit">确认</el-button>
      </div>
    </el-dialog>
    <!-- 添加选择下载内容弹窗 -->
    <el-dialog :visible.sync="visible.choseDownloadContent" :close-on-press-escape="false" @close="downClose">
      <div slot="title">
        <span class="text-black font-bold" style="font-size: 25px;">下载方式</span>

      </div>
      <chose-download-content :modelInfo="modelInfo" :projectWangpanUrl="projectWangpanUrl" ref="chose-download"></chose-download-content>

    </el-dialog>
    <!-- <el-drawer
  title="模型下载"
  :visible.sync="visible.choseDownloadContent"
  :direction="direction"
  :before-close="handleClose">
 
      <chose-download-content :modelInfo="modelInfo" :projectWangpanUrl="projectWangpanUrl"></chose-download-content>
</el-drawer> -->
  </div>
</template>

<script>
import autoHeightTable from '@/components/auto-height-table.vue'
import addVersion from './add-version.vue'
import addFile from './add-file.vue'
import dayjs from 'dayjs'
import hasPer from '@/utils/hasPermission'
import avatar from '@/components/avatar.vue'
import path from '@/api/path'
import fileDownload from 'js-file-download'
import choseDownloadContent from './choseDownloadContent.vue'
import Footer from '@/components/layout/footer.vue'
import {eventBus} from '@/utils/eventBus.js'
export default {
  components: { autoHeightTable, addVersion, addFile, avatar, choseDownloadContent, Footer },
  props: { data: {} },
  data() {
    return {
      is_show:true,
      ptotal:1,
      page:1,
      pageSize:25,
      hasPer,
      codeedit:``,
      direction:'rtl',
      dirlist:[],
      modelInfo: {},
      branch: '',
      recentTime: '',
      hasQuestion: false,
      question: 'README.md文件内缺少domain及task标签',
      activePath: [], // 当前路径集合
      tableData: [],
      activefilename:'',
      columns: [
        {
          label: '',
          prop: 'name'
        },
        {
          label: '',
          prop: 'size',
          width: '150px'
        },
        {
          label: '',
          prop: 'subject',
          width: '400px'
        },
        {
          label: '',
          prop: 'lastUpdateStr',
          width: '100px'
        }
      ],
      actionType: '',
      editRow: null,
      visible: {
        addVersion: false,
        addFile: false,
        asyncCommit: false,
        choseDownloadContent: false
      },
      loading: {
        table: false,
        addVersion: false,
        addFile: false
      },
      projectWangpanUrl: {
        url: ""
      },
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.system.userInfo
    },
    userBaseInfo() {
      return this.$store.state.system.userBaseInfo
    },
    branchs() {
      return this.$store.state.project.branchs
    },
    branchName() {
      if (this.branch !== '') {
        const res = this.branchs.find((item) => item.id === this.branch)
        return res.name
      } else {
        return ''
      }
    },
    project_id() {
      return this.modelInfo.id;
    },
    pathBreadcrumb() {
      return this.activePath.join('/')
    },
    contributor() {
      return [
        {
          avatar: this.userBaseInfo.avatar,
          username: this.userBaseInfo.login_name
        }
      ]
    }
  },
  created() {
    this.modelInfo = this.data
    this.getBranch()
    eventBus.$on('finishAddFile',()=>{
      this.finishAddFile()
    })
    if(this.$route.params.tab==='blob'){
      this.actionType = 'view'
      // this.activePath.push()
    }
  },
  mounted() { },
  watch: {
    // 监听$route对象的变化
    $route(to, from) {
      if(to.params.tab!=='blob'){
        this.Resetfile()
      }      
    }
  },
  methods: {
    getTableData() {
      this.loading.table = true
      this.$api.project
        .listfiles({
          id: this.project_id,
          path: this.pathBreadcrumb,
          branch: this.branchName,
          baseReq: {
          page: this.page,
          pageSize: this.pageSize
     }
        })
        .then((res) => {
          this.ptotal=res.data.total
          if(res.data.total>1){
            this.is_show=false
          }else{
            this.is_show=true
           
          }
          const { message } = res
          if (message === 'Success') {
            this.tableData = res.data.list
            this.tableData.forEach((item) => {
              item.lastUpdateStr = dayjs(item.lastCommitTime.replace(/-/g, "/")).from(
                dayjs(new Date())
              )
            })
            const lastCommitTimes = this.tableData.map((item) =>
              new Date(item.lastCommitTime).getTime()
            ) // lastCommitTimes 世纪秒集合
            const lastCommitTime = Math.max.apply(null, lastCommitTimes) // 取最大值便是最近的
            this.recentTime = dayjs(lastCommitTime).from(dayjs(new Date())) // 格式化
            this.dirlist= res.data.list.reduce((acc, item) => {
              if (item.isDir) {
               acc.push({ value: '/'+item.name });
              }
                return acc;
              }, []);
          }
        })
        .finally(() => {
          this.loading.table = false
        })
    },
    //添加文件文件夹查询
    addfileslist(path,branch) {
      this.$api.project
        .listfiles({
          id: this.project_id,
          path: path,
          branch: branch,
          baseReq: {
          page: this.page,
          pageSize: this.pageSize
     }
        })
        .then((res) => {
          const { message } = res
          if (message === 'Success') {
            this.dirlist= res.data.list.reduce((acc, item) => {
              if (item.isDir) {
               acc.push({ value: '/'+item.path });
              }
                return acc;
              }, []);
  
          }
        })
    },
    // 更新表格高度
    updateTableHeight() {
      this.$refs['auto-height-table'].updateHeight()
    },
    rowClick(row) {
      const isDir = row.isDir
      if (isDir) {
        this.activePath.push(row.name)
        this.getTableData()
      }
      //如果是文件点击预览
      if(!isDir ){
      this.activePath.push(row.name) 
      this.editRow = Object.assign({}, row)
      sessionStorage.setItem('isLFS',row.isLFS)
      this.actionType = 'view'
      this.activefilename=row.path
      var routerpath = ''
        if(this.$store.state.project.type==='M')routerpath='models'
        if(this.$store.state.project.type==='D')routerpath='datasets'    
        if(this.$store.state.project.type==='C')routerpath='codes'    
        this.$router.push('/'+routerpath+'/'+this.$route.params.username_en+'/'+this.$route.params.project_name_en+'/'+'blob/'+this.branchName+'/'+row.path);
     
      }
    },
    handleCellClick(row, column, cell, event){
      event.stopPropagation();
    },    // 添加版本
    addVersion() {
      this.visible.addVersion = true
    },
    toMarkdown(content) {
      const res = marked(content)
      // 重新设置图片路径，解决图片404问题
      const markdownImgs = document.querySelectorAll('.markdown-body img')
      markdownImgs.forEach((i) => {
        // i.src = path.key.image + i.src
      })
      return res
    },
    // 添加文件
    addFile() {
      this.visible.addFile = true
      this.$nextTick(() => {
        this.$refs['add-file'].setactivepath(this.activePath)
      })
   
    },
    // 选择下载方式
    choseDownloadContent() {
      if (!this.userInfo) {
        this.$store.dispatch('system/toLogin', true)
        return
      }
      this.visible.choseDownloadContent = true
      // this.getProjectWangpanurl( this.project_id,      
      // this.branchName)
      // console.log(this.modelInfo.wangpan_url)
      this.projectWangpanUrl.url = this.modelInfo.wangpan_url
    },
    //文件分页
    paginationChange({ size, current }){
      this.pageSize = size
      this.page = current
      this.getTableData()
    },
    //关闭下载方式弹窗
    downClose(){
        this.$refs['chose-download'].ResetType()
    },
    handleClose(){
      this.visible.choseDownloadContent = false
    },
    // 弹窗提示异步提交
    infoAsyncCommit() {
      this.visible.asyncCommit = true
    },
    // 查看
    view(row) {
      // this.editRow = Object.assign({}, row)
      // this.actionType = 'view'
    },
    // 编辑
    edit(row) {
      // this.editRow = Object.assign({}, row)
      // this.actionType = 'edit'
    },
    // 下载
    download(row) {
      if (!this.userInfo) {
        this.$store.dispatch('system/toLogin', true)
        return
      }
      this.$set(row, 'downloadLoading', true)
      this.$api.file
        .downupload({
          project_id: this.project_id,
          filePath: this.activePath.concat([row.name]).join('/')
        })
        .then((res) => {
          if (res.data) {
            this.downloadByFileLink(row.link, row.name)
          }
        })
        .catch((err) => {
          this.$message.error('下载失败')
        })
        .finally(() => {
          this.$set(row, 'downloadLoading', false)
        })
    },
    // 通过文件链接下载（需要设置代理解决跨域问题）
    downloadByFileLink(link, fileName) {
      var eleLink = document.createElement('a')
      eleLink.target = '_blank'
      eleLink.download = fileName
      eleLink.style.display = 'none'
      const linkArr = link.split('/')
      const arr = linkArr.slice(3)
      const href = path.key.downloadFile + '/' + arr.join('/')
      eleLink.href = href
      // 触发点击
      document.body.appendChild(eleLink)
      eleLink.click()
    },
    // 添加版本完成事件
    finishAddVersion() {
      this.$refs['add-version'].finish().then((form) => {
        if (form) {
          // 表单验证通过
          this.loading.addVersion = true
          this.$api.project
            .addbranch({
              id: this.project_id,
              branch: form.version
            })
            .then((res) => {
              if (res.message === 'Success') {
                this.$message.success('添加版本成功')
                this.getBranch()
                this.visible.addVersion = false
              }
            })
            .finally(() => {
              this.loading.addVersion = false
            })
        }
      })
    },
    //关闭添加文件窗口
    close(){
      // this.visible.addFile = false
      this.$refs['add-file'].closeListedFiles()
      this.getTableData()
    },
    // 添加文件完成事件
    finishAddFile() {

      this.$refs['add-file'].finish().then((form) => {
        if (form) {
          // 表单验证通过
          this.loading.addFile = true
          this.$api.file
            .addfiles({
              id: this.project_id,
              branch: form.branchName,
              files: form.file,
              commit: form.commit,
              wangpan_url: form.netDiskLink,
              git_folder:form.git_folder
            })
            .then((res) => {
              if (res.message === 'Success') {
                this.$message.success('添加文件成功')
                // 隐藏上传文件列表，清除已上传文件列表
                this.$refs['add-file'].closeUploader()
                this.getTableData()
              }
            })
            .finally(() => {
              this.loading.addFile = false
            })
        }
      })
    },
    aknowledgeAsyncCommit() {
      this.visible.asyncCommit = false
    },
    // 分支change
    branchChange() {
      this.getCommitHistory(this.branchName)
      this.getTableData()
    },
    // 目录切换
    changePath(path) {
      if(path.name){       
          return
      }
      if (path) {
        if(path!=this.activefilename){
        const index = this.activePath.findIndex((item) => item === path)
        this.activePath = this.activePath.slice(0, index + 1)
        this.actionType=''
        }
       
      } else {
        this.actionType = ''
        this.activePath = []    
        var routerpath = ''
        if(this.$store.state.project.type==='M')routerpath='models'
        if(this.$store.state.project.type==='D')routerpath='datasets'    
        if(this.$store.state.project.type==='C')routerpath='codes'    
        this.$router.push('/'+routerpath+'/'+this.$route.params.username_en+'/'+this.$route.params.project_name_en+'/'+'file');
      }
      this.getTableData()
    },
    Resetfile(){
      this.actionType = ''
      this.activePath = []  
      this.getTableData()
    },
    // 获取分支列表
    getBranch() {
      let project_type = this.$store.state.project.type
      this.$api.project
        .branchlist({
          project_id: this.project_id,
          project_type
        })
        .then((res) => {
          const { message } = res
          if (message === 'Success') {
            let arr = res.data.list
            if (arr.length > 0) {
              arr = arr.map((item) => {
                const { id, branch: name, project_id, created_at } = item
                return {
                  id,
                  name,
                  project_id,
                  created_at
                }
              })
              this.$store.dispatch('project/setBranchs', arr)
              if (!this.branch) {
                this.branch = arr.find((i) => i.name === 'main')?.id
              }
              this.getTableData()
              this.getCommitHistory(this.branchName)
            }
          }
        })
    },
  
    // 获取文件提交记录
    getCommitHistory(branchName) {
      this.$api.project
        .commithistory({
          project_id: this.project_id,
          branch: branchName
        })
        .then((res) => {
          const { message } = res
          if (message === 'Success') {
          }
        })
    },
    getProjectWangpanurl(projectId, branch) {

      this.$api.project
        .getProjectWangpanurl({
          project_id: projectId,
          branch
        })
        .then((res) => {
          if (res.message === 'Success') {
            let {
              projWangpanurl
            } = res.data
            this.projectWangpanUrl = projWangpanurl

          }
        })
        .finally(() => {

        })
    },
  }
}
</script>
<style lang="scss" scoped>

.page {

  min-height: calc(100vh - 300px);
}

.table-header {
  background: #f2f2f2;
  border-bottom: 2px solid var(--primary-color);
}

.file-is-dir {
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

.path {
  cursor: pointer;

  &:hover {
    color: var(--primary-color);
  }
}

.page-content {
  width: 1600px;
  margin: 0 auto;
}
.user-avatar{
  width: 21px;
  height: 21px;
}
@media only screen and (max-width: 767px){
  .common-button, .dwn{
    display: none;
  }
  .user-avatar{
  width: 80px;
  height: 80px;
}
.table-header{
  margin-top: 30px;
}
}

</style>
